import React from "react"
import { IPunchBundle, IUIUser } from "../../../models"
import Table from "../../common/Table"
import { TableHeader, TableBody, TableRow, TableHeaderColumn, TableRowColumn } from "material-ui"
import strings from "../../../localization/strings"
import AccountStore from "../../../stores/AccountStore"
import * as timeHelper from "../../../helpers/timeHelper"
import * as hierarchyHelper from "../../../helpers/hierarchyHelper"
import * as payGroupAndTypeHelper from "../../../helpers/payGroupAndTypeHelper"
import moment from "moment"
import { red500 } from "material-ui/styles/colors"
import { checkPositionFieldAvailable } from "../../../helpers/positionHelper"
import { checkPhaseFieldAvailable } from "../../../helpers/punchHelper"
interface IProps {
    globalPunchEmployees: IUIUser[]
    punchBundles: IPunchBundle[]
    selectedPunchBundles: IPunchBundle[]
    handleSelect(selectedPunchBundles: IPunchBundle[]): void
}

const GlobalPunchTable: React.SFC<IProps> = (props: IProps) => {
    return (
        <Table
            height={"calc(100vh - 380px)"}
            fixedHeader
            items={props.punchBundles}
            selectedItems={props.selectedPunchBundles}
            handleSelect={props.handleSelect}
            selectObjectName="Punch"
        >
            <TableHeader>
                <TableRow className="ShortSelectBoxTableHeader">
                    <TableHeaderColumn style={style.col}>{strings.Employee}</TableHeaderColumn>
                    <TableHeaderColumn style={style.timeCol}>{strings.Punch_Time}</TableHeaderColumn>
                    <TableHeaderColumn style={style.col}>{strings.Hierarchy}</TableHeaderColumn>
                    {AccountStore.getJobsEnabled() &&
                        <TableHeaderColumn style={style.col}>{ checkPositionFieldAvailable('singular') ? AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel : strings.Job}</TableHeaderColumn>
                    }
                    {AccountStore.getPhasesEnabled() &&
                        <TableHeaderColumn style={style.col}>{ checkPhaseFieldAvailable("singular") ? AccountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.SingularPhaseLabel : strings.Phase}</TableHeaderColumn>
                    }
                    <TableHeaderColumn style={style.col}>{checkPositionFieldAvailable('singular') ? AccountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.SingularPositionLabel: strings.Position}</TableHeaderColumn>
                    <TableHeaderColumn style={style.payTypeCol}>{strings.Pay_Type}</TableHeaderColumn>
                    {AccountStore.getEquipmentEnabled() &&
                        <TableHeaderColumn style={style.col}>{strings.Equipment}</TableHeaderColumn>
                    }
                </TableRow>
            </TableHeader>
            <TableBody>
                {props.punchBundles.map((punchBundle, index) => {
                    const punch = punchBundle.Punch
                    const employee = props.globalPunchEmployees.find(i => i.Id === punch.UserId)
                    const punchHierarchyName = hierarchyHelper.getFullyQualifiedLevelNameById(punch.HierarchyItemId)
                    const payTypeName = payGroupAndTypeHelper.getPayTypeNameById(punch.PayTypeId)
                    return (
                        <TableRow className="ShortSelectBoxTableRow" key={index} selected={props.selectedPunchBundles.find(i => i.Punch.Id === punch.Id) ? true : false}>
                            <TableRowColumn style={style.col}>{`${employee.FirstName} ${employee.LastName}`}</TableRowColumn>
                            <TableRowColumn style={style.timeCol}>{moment(timeHelper.keepConvertUTCToLocal(punch.RoundingRuleId ? punch.RoundedDateTimeLocal : punch.DateTimeLocal)).format("MM/DD/YY hh:mma")}</TableRowColumn>
                            <TableRowColumn style={style.col}>
                                <span
                                    title={punchHierarchyName.includes(strings.Hierarchy_Removed) ? null : hierarchyHelper.getFullPathLabel(punch.HierarchyItemId)}
                                    style={{ color: punchHierarchyName.includes(strings.Hierarchy_Removed) && red500 }}
                                >
                                    {punchHierarchyName.includes(strings.Hierarchy_Removed) ? strings.Hierarchy_Removed : punchHierarchyName}
                                </span>
                            </TableRowColumn>
                            {AccountStore.getJobsEnabled() &&
                                <TableRowColumn style={style.col}>{punch.JobName}</TableRowColumn>
                            }
                            {AccountStore.getPhasesEnabled() &&
                                <TableRowColumn style={style.col}>{punch.PhaseName}</TableRowColumn>
                            }
                            <TableRowColumn style={style.col}>{punchBundle.PunchPosition && punchBundle.PunchPosition.Position && punchBundle.PunchPosition.Position.Name}</TableRowColumn>
                            <TableRowColumn style={{ ...style.payTypeCol, color: payTypeName === strings.invalid && red500 }}>{payTypeName}</TableRowColumn>
                            {AccountStore.getEquipmentEnabled() &&
                                <TableRowColumn style={style.col}>{punch.EquipmentName}</TableRowColumn>
                            }
                        </TableRow>
                    )
                }
                )}
            </TableBody>
        </Table>
    )
}

export default GlobalPunchTable

const style = {
    col: {
        paddingLeft: 5,
        paddingRight: 5
    },
    timeCol: {
        paddingLeft: 5,
        paddingRight: 5,
        width: 110
    },
    payTypeCol: {
        paddingLeft: 5,
        paddingRight: 5,
        width: 75
    }
}